import { IonButton, IonContent, IonHeader, IonIcon, IonPage, IonTitle } from '@ionic/react';
import { arrowForwardOutline, checkmarkOutline, logoWhatsapp, openOutline, playCircleOutline } from 'ionicons/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import IonToolbar from '../../../components/Modal/ModalToolbar';
import '../CadastroLayout/CadastroLayout.css';
import './CadastroSucesso.css';

const CadastroSucesso: React.FC = () => {
  const history = useHistory();

  return (
    <IonPage className="cadastro-page cadastro-sucesso-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="cadastro-toolbar">
          <IonTitle>Acesso liberado</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="cadastro-content">
        <main className="cadastro-sucesso-container">
          <section className="cadastro-sucesso-card" aria-labelledby="cadastro-sucesso-title">
            <span className="cadastro-sucesso-icon"><IonIcon icon={checkmarkOutline} aria-hidden="true" /></span>
            <h1 id="cadastro-sucesso-title">Seu acesso está liberado!</h1>
            <p className="cadastro-sucesso-description">Bem-vindo ao Xeguei. Sua conta foi criada com sucesso e você já pode começar a usar os recursos da plataforma.</p>
            <IonButton className="cadastro-sucesso-primary" expand="block" onClick={() => history.replace('/login')}>
              Quero acessar minha conta
              <IonIcon icon={arrowForwardOutline} slot="end" aria-hidden="true" />
            </IonButton>
          </section>

          <section className="cadastro-sucesso-resources" aria-labelledby="cadastro-sucesso-resources-title">
            <h2 id="cadastro-sucesso-resources-title">Para começar bem</h2>
            <a className="cadastro-sucesso-resource" href="https://www.youtube.com/playlist?list=PLiEmugyBhYXUITYtohwaDSuZKAdcyaKT6" target="_blank" rel="noopener noreferrer">
              <span className="cadastro-sucesso-resource-icon"><IonIcon icon={playCircleOutline} aria-hidden="true" /></span>
              <span className="cadastro-sucesso-resource-copy">
                <strong>Treinamento Xeguei</strong>
                <span>Em 20 minutos, conheça os recursos e aprenda a usar o sistema.</span>
                <span className="cadastro-sucesso-resource-action">Assistir ao treinamento<IonIcon icon={openOutline} aria-hidden="true" /></span>
              </span>
            </a>
            <a className="cadastro-sucesso-resource cadastro-sucesso-support" href="https://api.whatsapp.com/send?phone=5511963927646" target="_blank" rel="noopener noreferrer">
              <span className="cadastro-sucesso-resource-icon"><IonIcon icon={logoWhatsapp} aria-hidden="true" /></span>
              <span className="cadastro-sucesso-resource-copy">
                <strong>Precisa de ajuda?</strong>
                <span>Fale com nossa equipe pelo WhatsApp: (11) 96392-7646.</span>
                <span className="cadastro-sucesso-resource-action">Falar com suporte<IonIcon icon={openOutline} aria-hidden="true" /></span>
              </span>
            </a>
          </section>
        </main>
      </IonContent>
    </IonPage>
  );
};

export default CadastroSucesso;
